import { MessageCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useSite } from "@/context/SiteContext";

export default function ContactDialog() {
  const { contactOpen, setContactOpen, contactIntent, settings } = useSite();

  const copy =
    contactIntent === "team"
      ? {
          title: "Entra nel team IEM",
          desc: "Raccontaci chi sei e quale ruolo vuoi ricoprire. Scrivici su WhatsApp: ti risponderemo entro 24 ore.",
        }
      : {
          title: "Candidati come Creator",
          desc: "Scrivici su WhatsApp. Ogni candidatura è riservata e valutata individualmente.",
        };

  return (
    <Dialog open={contactOpen} onOpenChange={setContactOpen}>
      <DialogContent
        className="border-[#1A1A1A] bg-[#0d0d0d] p-6 text-[#F5F3EE] sm:max-w-md sm:p-8"
        data-testid="contact-dialog"
      >
        <DialogHeader>
          <div className="mb-2 flex items-center gap-3">
            <span className="h-px w-8 bg-gold/70" />
            <span className="text-[10px] tracking-[0.3em] uppercase text-gold font-semibold">
              Contatto riservato
            </span>
          </div>
          <DialogTitle className="font-serif text-2xl sm:text-3xl text-[#F5F3EE]">{copy.title}</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-[#969696]">{copy.desc}</DialogDescription>
        </DialogHeader>
        <div className="mt-4 flex flex-col gap-3">
          <a
            data-testid="contact-whatsapp-btn"
            href={settings.whatsapp_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between border border-gold/50 bg-gold/10 px-5 py-4 text-sm font-semibold tracking-wide text-gold transition-all duration-300 hover:bg-gold hover:text-[#080808]"
          >
            <span className="flex items-center gap-3">
              <MessageCircle size={18} /> Continua su WhatsApp
            </span>
            <span aria-hidden>→</span>
          </a>
          <p className="text-center text-xs tracking-wide text-[#969696]" data-testid="contact-whatsapp-number">
            WhatsApp diretto: <span className="font-semibold text-[#F5F3EE]">+39 328 711 6258</span>
          </p>
          <p className="mt-1 text-center text-[11px] leading-relaxed text-[#969696]">
            Conversazioni tutelate da accordo di riservatezza. Nessun dato condiviso senza consenso.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
